import store from '../store/store';
import { SHOW_TAB } from '../store/schema/PersonalizationConstants';

export default function getShouldShowTabHint(): boolean {
    const { personalizationSuggestions } = store();
    return personalizationSuggestions.tabHintSuggestion.prefer === SHOW_TAB;
}
